// SelectedSupplierContext.tsx
import React, { createContext, useState } from "react";

interface Supplier {
    id: string;
    name: string;
    // Add other fields as needed
}

interface SelectedSupplierContextType {
    selectedSupplier: Supplier | null;
    setSelectedSupplier: (supplier: Supplier | null) => void;
}

const SelectedSupplierContext = createContext<SelectedSupplierContextType | undefined>(undefined);

const SelectedSupplierProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [selectedSupplier, setSelectedSupplier] = useState<Supplier | null>(null);

    return (
        <SelectedSupplierContext.Provider value={{ selectedSupplier, setSelectedSupplier }}>
            {children}
        </SelectedSupplierContext.Provider>
    );
};

export default SelectedSupplierProvider;
export { SelectedSupplierContext };
